// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'vertical',
  themeColorPresets: 'default',
  themeFontFamily: 'publicSans',
  themeStretch: false,
  // 'integrate' — sidebar background uses the active primary color (vivid).
  // 'apparent'  — sidebar uses the neutral surface color (subtle).
  themeNavColor: 'integrate',
  // Hex string ('#rrggbb') used when themeColorPresets === 'custom'.
  // null means the user has never picked a custom color yet.
  themeCustomColor: null,
};
